import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  PeopleClient,
  PaginatedResponseOfPeopleListDto,
  PersonDto,
  CreatePersonRequest,
  UpdatePersonRequest,
  DeletePersonDto,
  PersonAgeStatus,
  OrganizationUnitDto,
} from '../generated/api-client';

export {
  PaginatedResponseOfPeopleListDto,
  PeopleListDto,
  PersonDto,
  CreatePersonRequest,
  UpdatePersonRequest,
  DeletePersonDto,
} from '../generated/api-client';

/**
 * Thin wrapper over the NSwag-generated PeopleClient.
 * Feature services should inject this class instead of PeopleClient directly.
 */
@Injectable({ providedIn: 'root' })
export class PeopleApiService {
  constructor(private readonly client: PeopleClient) {}

  get(
    searchTerm?: string | null,
    unitIds?: string[] | null,
    sortBy?: string | null,
    sortDirection?: string | null,
    page?: number,
    pageSize?: number
  ): Observable<PaginatedResponseOfPeopleListDto> {
    return this.client.get(searchTerm, unitIds, sortBy, sortDirection, page, pageSize);
  }

  getById(id: string): Observable<PersonDto> {
    return this.client.getById(id);
  }

  create(request: CreatePersonRequest): Observable<PersonDto> {
    return this.client.create(request);
  }

  update(id: string, request: UpdatePersonRequest): Observable<PersonDto> {
    return this.client.update(id, request);
  }

  delete(id: string, deleteDto?: DeletePersonDto): Observable<void> {
    return this.client.delete(id, deleteDto);
  }

  calculateAgeStatus(birthDate: string): Observable<PersonAgeStatus> {
    return this.client.calculateAgeStatus(birthDate);
  }

  getAuthorizedUnits(): Observable<OrganizationUnitDto[]> {
    return this.client.getAuthorizedUnits();
  }
}
